// extracted by mini-css-extract-plugin
module.exports = {"item":"HgEKh8V4kmti2ppzdJRiL"};